import { render, staticRenderFns } from "./CRMLawcaseCourt.vue?vue&type=template&id=93a605b0&scoped=true&"
import script from "./CRMLawcaseCourt.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseCourt.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseCourt.vue?vue&type=style&index=0&id=93a605b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a605b0",
  null
  
)

export default component.exports